import React, { useContext } from "react";
import { ConfirmDialog } from "sprint-common-web";

import { useFileRecordApi } from "../../../../../common/api/master-api/file-records/useFileRecordApi";
import { FileRecordStatus } from "../../../../../common/types/FileRecordStatus";
import { FileRecordListingContext } from "../../context/FileRecordListingContext";

interface ChangeFileRecordToEditingListingDialogProps {
    onClose(): void;
    isOpen: boolean;
    itemId: string;
}

export const ChangeFileRecordToEditingListingDialog: React.VFC<ChangeFileRecordToEditingListingDialogProps> = ({
    itemId,
    isOpen,
    onClose
}: ChangeFileRecordToEditingListingDialogProps) => {
    const { changeFileRecordToEditing } = useFileRecordApi();

    const { updateFileRecordStatus } = useContext(FileRecordListingContext);

    const handleConfirmation = async () => {
        await changeFileRecordToEditing({ fileRecordId: itemId });

        updateFileRecordStatus(itemId, FileRecordStatus.Editing);

        onClose();
    };

    return (
        <ConfirmDialog
            title="Change status to editing"
            text="Are you sure you want to update given file record to editing?"
            hidden={!isOpen}
            confirm={{ onClick: handleConfirmation }}
            cancel={{ onClick: onClose }}
        />
    );
};
